import {
  ContentHubType,
  AlternativeContentHubType,
  CollectionType,
  AlternativeCollectionType,
  LandingType,
} from 'src/constants';
import { MyLearningPageContentSections } from 'src/pages/MyLearningPage/constants';
import { getUrlPrefix } from 'src/services/http/user';

interface LessonUrlParams {
  lessonSlug: string;
  courseSlug?: string;
  pathSlug?: string;
  sectionSlug?: string;
}

type MyLearningUrlParams = MyLearningPageContentSections | ':status';

export const LEARNING_PATH_URL_PATH = 'path';
export const COURSE_URL_PATH = 'course';
export const LESSON_URL_PATH = 'lesson';

export const MY_LEARNING_URL_PATH = 'my-learning';
export const CATALOG_URL_PATH = 'catalog';

export const HUB_URL_PATH = 'hub';
export const COLLECTION_URL_PATH = 'collection';

export const LANDING_URL_PATH = '/landing';

export const withPrefix = (url: string, prefix?: string): string =>
  typeof prefix === 'string' ? `${prefix}${url}` : `${getUrlPrefix()}${url}`;

export const stripLeadingSlash = (url: string): string => (url.startsWith('/') ? url.slice(1) : url);

export const getPathUrl = (pathSlug: string, hasSurvey?: boolean): string =>
  `/${LEARNING_PATH_URL_PATH}/${pathSlug}${hasSurvey ? '/survey' : ''}`;

export const getCourseUrl = (courseSlug: string, pathSlug?: string, hasSurvey?: boolean): string => {
  const learningPathUrl = pathSlug ? getPathUrl(pathSlug) : '';

  return `${learningPathUrl}/${COURSE_URL_PATH}/${courseSlug}${hasSurvey ? '/survey' : ''}`;
};

export const getLessonUrl = ({ lessonSlug, courseSlug, pathSlug, sectionSlug }: LessonUrlParams): string => {
  const courseUrl = courseSlug ? getCourseUrl(courseSlug, pathSlug) : '';
  const sectionFragment = sectionSlug ? `#${sectionSlug}` : '';

  return `${courseUrl}/${LESSON_URL_PATH}/${lessonSlug}${sectionFragment}`;
};

export const getHubUrl = (
  type: ContentHubType | AlternativeContentHubType,
  sectionId?: string,
  hubSlug?: string,
): string => {
  const hubFragment = hubSlug ? `/${hubSlug}` : '';
  const sectionFragment = sectionId ? `#${sectionId}` : '';

  return `/${HUB_URL_PATH}/${type}${hubFragment}${sectionFragment}`;
};

export const getCollectionUrl = (type: CollectionType | AlternativeCollectionType, collectionSlug?: string): string => {
  const collectionFragment = collectionSlug ? `/${collectionSlug}` : '';

  return `/${COLLECTION_URL_PATH}/${type}${collectionFragment}`;
};

export const getCertificationUrl = (certificationSlug?: string): string => {
  const certificationFragment = certificationSlug ? `/${certificationSlug}` : '';

  return `/${ContentHubType.CERTIFICATIONS}${certificationFragment}`;
};

export const getCatalogUrl = (filter?: string): string => `/${CATALOG_URL_PATH}${filter || ''}`;

export const getLandingUrl = (type: LandingType, slug?: string): string => {
  const landingFragment = slug ? `/${slug}` : '';

  return `/${type}${landingFragment}`;
};

export const getMyLearningUrl = (status: MyLearningUrlParams): string => `/${MY_LEARNING_URL_PATH}/${status}`;
